import { Gauge, ShieldCheck, Snowflake } from "lucide-react";
import { JackstoneLogo } from "@/components/Logo";

export const LoginHero = () => (
  <div
    className="relative hidden lg:flex flex-col justify-between p-10 text-white overflow-hidden"
    style={{
      backgroundImage: `linear-gradient(rgba(31,58,82,0.86), rgba(31,58,82,0.92)), url("https://images.unsplash.com/photo-1714504904786-b6732390b206?crop=entropy&cs=srgb&fm=jpg&q=85")`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundColor: "#1f3a52",
    }}
  >
    <div>
      <JackstoneLogo className="h-9 w-auto" variant="light" />
      <div className="mt-3 text-[10px] subtitle tracking-[0.3em] uppercase text-[#ccb795]">
        Since 1937 · Frozen Today, Fresh Tomorrow
      </div>
    </div>

    <div className="max-w-xl">
      <div className="eyebrow text-[#ccb795] mb-5">/ 01 — Compliance</div>
      <h1 className="font-display text-6xl md:text-7xl leading-[0.95] tracking-tight text-white">
        TRACEABLE
        <br />
        PRESSURE
        <br />
        <span className="text-[#ccb795]">TESTS.</span>
      </h1>
      <p className="mt-8 font-body text-slate-300 text-base leading-relaxed max-w-md">
        Log every vessel, every weld, every failure point with audit-grade
        precision. Export certificates the day regulators ask.
      </p>
    </div>

    <div className="grid grid-cols-3 gap-6 max-w-xl">
      <div className="border-l-2 border-[#39678f] pl-4">
        <ShieldCheck className="w-5 h-5 text-[#ccb795] mb-2" />
        <div className="subtitle text-[10px] uppercase tracking-widest text-slate-400">
          PED 2014/68/EU
        </div>
        <div className="font-body text-sm text-white">Compliant records</div>
      </div>
      <div className="border-l-2 border-[#39678f] pl-4">
        <Gauge className="w-5 h-5 text-[#ccb795] mb-2" />
        <div className="subtitle text-[10px] uppercase tracking-widest text-slate-400">
          PTF1 – PTF9
        </div>
        <div className="font-body text-sm text-white">Leak-point map</div>
      </div>
      <div className="border-l-2 border-[#39678f] pl-4">
        <Snowflake className="w-5 h-5 text-[#ccb795] mb-2" />
        <div className="subtitle text-[10px] uppercase tracking-widest text-slate-400">
          Plate · Spiral · IQF
        </div>
        <div className="font-body text-sm text-white">Every vessel</div>
      </div>
    </div>
  </div>
);
